import type { Spacings } from '@rulebooks/evidend-titan';
import { Card, List, ListItem } from '@rulebooks/evidend-titan';
import { Trans } from '@lingui/macro';
import { GreenOkCircleIcon } from 'components/GreenOkCircleIcon/GreenOkCircleIcon';
import { RedCancelCircleIcon } from 'components/RedCancelCircleIcon/RedCancelCircleIcon';
import type { DelegationDetails } from 'generated/gql';
import React from 'react';

interface IDelegateRightsCard {
  rights: DelegationDetails;
  spaceAfter?: Spacings;
  backgroundVariant?: 'white' | 'grey';
}
const DelegateRightsCard = ({
  rights,
  spaceAfter = 6,
  backgroundVariant = 'white',
}: IDelegateRightsCard) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { meeting, voting, dividend } = rights;
  return (
    <Card backgroundVariant={backgroundVariant} spaceAfter={spaceAfter}>
      <List spaceAfter={0} type="ul">
        <ListItem prefixAdornment={voting ? <GreenOkCircleIcon /> : <RedCancelCircleIcon />}>
          <Trans>Stemrecht</Trans>
        </ListItem>
        <ListItem prefixAdornment={meeting ? <GreenOkCircleIcon /> : <RedCancelCircleIcon />}>
          <Trans>Vergaderrecht</Trans>
        </ListItem>
        <ListItem prefixAdornment={dividend ? <GreenOkCircleIcon /> : <RedCancelCircleIcon />}>
          <Trans>Dividendrecht</Trans>
        </ListItem>
      </List>
    </Card>
  );
};

export default DelegateRightsCard;
